import React from 'react'
import { Table, Button, Tag, Badge } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
import type { ColumnsType } from 'antd/es/table'
import type { Dispute } from '../types/dispute.types'

interface DisputesTableProps {
    disputes: Dispute[]
    onRowClick: (dispute: Dispute) => void
}

export const DisputesTable: React.FC<DisputesTableProps> = ({ disputes, onRowClick }) => {
    const columns: ColumnsType<Dispute> = [
        {
            title: 'Dispute ID',
            dataIndex: 'id',
            key: 'id',
            render: (id: string) => <strong>{id}</strong>,
        },
        {
            title: 'Order ID',
            dataIndex: 'orderId',
            key: 'orderId',
        },
        {
            title: 'Customer',
            dataIndex: 'customer',
            key: 'customer',
        },
        {
            title: 'Merchant',
            dataIndex: 'merchant',
            key: 'merchant',
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'Priority',
            dataIndex: 'priority',
            key: 'priority',
            render: (priority: string) => {
                const colors = {
                    low: 'blue',
                    medium: 'orange',
                    high: 'red',
                    critical: 'purple',
                }
                return <Tag color={colors[priority as keyof typeof colors]}>{priority.toUpperCase()}</Tag>
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status: string) => {
                const colors = {
                    open: 'orange',
                    in_progress: 'blue',
                    resolved: 'green',
                    closed: 'gray',
                }
                return <Tag color={colors[status as keyof typeof colors]}>{status.replace('_', ' ').toUpperCase()}</Tag>
            },
        },
        {
            title: 'Age',
            dataIndex: 'ageHours',
            key: 'ageHours',
            render: (hours: number) => {
                const color = hours > 48 ? 'red' : hours > 24 ? 'orange' : 'blue'
                return <Badge color={color} text={`${hours}h`} />
            },
        },
        {
            title: 'Assigned To',
            dataIndex: 'assignedTo',
            key: 'assignedTo',
            render: (agent?: string) => agent || <Tag>Unassigned</Tag>,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Button type="link" icon={<EyeOutlined />} onClick={() => onRowClick(record)}>
                    View
                </Button>
            ),
        },
    ]

    return (
        <Table
            columns={columns}
            dataSource={disputes}
            rowKey="id"
            onRow={(record) => ({
                onClick: () => onRowClick(record),
                style: { cursor: 'pointer' },
            })}
            pagination={{
                total: disputes.length,
                pageSize: 10,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} disputes`,
            }}
        />
    )
}
